export default __webpack_public_path__ + "static/media/music-big.ea962a0c.jpg";